module.exports = __webpack_public_path__ + "assets/img/sb.d2f7945a.png";